import InlineEditorBase from '@ckeditor/ckeditor5-editor-inline/src/inlineeditor'

import { builtinPlugins, defaultConfig } from '../common'

class InlineEditor extends InlineEditorBase {}

InlineEditor.builtinPlugins = builtinPlugins
InlineEditor.defaultConfig = defaultConfig

export default InlineEditor
